import { render, staticRenderFns } from "./capital.vue?vue&type=template&id=35c1f66c&scoped=true"
import script from "./capital.vue?vue&type=script&lang=js"
export * from "./capital.vue?vue&type=script&lang=js"
import style0 from "./capital.vue?vue&type=style&index=0&id=35c1f66c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1f66c",
  null
  
)

export default component.exports